__turbopack_context__.v({
  "actions": "CookieConsent-module__dGBuNW__actions",
  "body": "CookieConsent-module__dGBuNW__body",
  "btnGhost": "CookieConsent-module__dGBuNW__btnGhost",
  "btnPrimary": "CookieConsent-module__dGBuNW__btnPrimary",
  "catDesc": "CookieConsent-module__dGBuNW__catDesc",
  "catItem": "CookieConsent-module__dGBuNW__catItem",
  "catList": "CookieConsent-module__dGBuNW__catList",
  "catName": "CookieConsent-module__dGBuNW__catName",
  "close": "CookieConsent-module__dGBuNW__close",
  "cookieField": "CookieConsent-module__dGBuNW__cookieField",
  "cookieFields": "CookieConsent-module__dGBuNW__cookieFields",
  "cookieHead": "CookieConsent-module__dGBuNW__cookieHead",
  "cookieItem": "CookieConsent-module__dGBuNW__cookieItem",
  "cookieList": "CookieConsent-module__dGBuNW__cookieList",
  "cookieNameVal": "CookieConsent-module__dGBuNW__cookieNameVal",
  "cookieSection": "CookieConsent-module__dGBuNW__cookieSection",
  "cookieToggle": "CookieConsent-module__dGBuNW__cookieToggle",
  "cookieType": "CookieConsent-module__dGBuNW__cookieType",
  "floating": "CookieConsent-module__dGBuNW__floating",
  "panel": "CookieConsent-module__dGBuNW__panel",
  "root": "CookieConsent-module__dGBuNW__root",
  "text": "CookieConsent-module__dGBuNW__text",
  "title": "CookieConsent-module__dGBuNW__title",
});
